import { useTheme } from "@mui/material/styles";
import logo from "./../assets/images/logo_white.png";

// ==============================|| LOGO SVG ||============================== //

const LogoSidebar = () => {
  const theme = useTheme();

  return <img src={logo} alt="20" width="110" />;
};

export default LogoSidebar;
